import { render } from "./TissSpSadtGuideForm.vue?vue&type=template&id=7dc36a5c"
import script from "./TissSpSadtGuideForm.vue?vue&type=script&lang=js"
export * from "./TissSpSadtGuideForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__